import { use } from 'react';
import { DropdownContexts } from '../../../../context/DropdownContext';
import { DropdownErrorMessageStyled } from './styles';

export const DropdownErrorMessage = () => {
  const { errorMessage, error, open } = use(DropdownContexts.useDropdown);

  if (!error || open || !errorMessage) return null;

  return <DropdownErrorMessageStyled>{errorMessage}</DropdownErrorMessageStyled>;
};
